import {
  trigger,
  animate,
  transition,
  style,
  query,
} from '@angular/animations';

export const fadeAnimation = trigger('fadeAnimation', [
  transition('void => *', [
    query(
      ':self',
      [
        style({
          opacity: 0,
        }),
      ],
      { optional: true }
    ),
    query(
      ':self',
      [
        style({
          opacity: 0,
        }),
        animate('3s cubic-bezier(0.2, 1.3, 0.7, 1)', style({ opacity: 1 })),
      ],
      { optional: true }
    ),
  ]),
  transition('* => void', [
    query(
      ':self',
      [
        style({
          opacity: 1,
        }),
      ],
      { optional: true }
    ),
    query(
      ':self',
      [
        style({
          opacity: 1,
        }),
        animate('3s cubic-bezier(0.2, 1.3, 0.7, 1)', style({ opacity: 0 })),
      ],
      { optional: true }
    ),
  ]),
  transition('* => *', [
    query(
      ':self',
      [
        style({
          opacity: 0,
        }),
      ],
      { optional: true }
    ),
    query(
      ':self',
      [
        style({
          opacity: 0,
        }),
        animate(
          '3s cubic-bezier(0.2, 1.3, 0.7, 1)',
          style({
            opacity: 1,
          })
        ),
      ],
      { optional: true }
    ),
  ]),
]);
